import React from "react";

export const withFilteredProps = (Component) => (props) => {
    const { children, context, data, id, locale } = props;

    const { state } = context;
    const { settings } = state;
    const { userSettings } = settings;

    const filteredProps = {
        children,
        data,
        id,
        locale,
        userSettings,
    };

    return <Component {...filteredProps} />;
};
